/**
 * Updates the recently viewed products in localStorage.
 *
 * FIFO of product ids (newest first), written on every PDP visit (inline
 * module in snippets/scripts.liquid) and read by the search modal's
 * "Deine zuletzt angesehenen Produkte" area. All storage access is wrapped
 * in try/catch — private mode / quota errors degrade to an empty list.
 */
const STORAGE_KEY = 'purelei:viewed-products';

export class RecentlyViewed {
  /** @static @constant {number} The maximum number of products to store */
  static #MAX_PRODUCTS = 8;

  /**
   * Adds a product to the recently viewed products list.
   * @param {string} productId - The ID of the product to add.
   */
  static addProduct(productId) {
    let viewedProducts = this.getProducts();

    viewedProducts = viewedProducts.filter((/** @type {string} */ id) => id !== productId);
    viewedProducts.unshift(productId);
    viewedProducts = viewedProducts.slice(0, this.#MAX_PRODUCTS);

    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(viewedProducts));
    } catch {
      /* private mode / quota — ignore */
    }
  }

  static clearProducts() {
    try {
      localStorage.removeItem(STORAGE_KEY);
    } catch {
      /* private mode / quota — ignore */
    }
  }

  /**
   * Retrieves the list of recently viewed products from local storage.
   * @returns {string[]} The list of viewed products.
   */
  static getProducts() {
    try {
      const parsed = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      return Array.isArray(parsed) ? parsed.filter((id) => typeof id === 'string') : [];
    } catch {
      return [];
    }
  }
}
